import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Plus, Calendar, CheckCircle, Clock, AlertCircle, Trash2 } from 'lucide-react';
import AlertBox from '../../Components/AlertBox';

// ✅ Corrected import
import ApiService from '../services/api';

const MilestoneList = ({ projects }) => {
  const [milestones, setMilestones] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAlert, setShowAlert] = useState(null);

  // Fetch milestones function
  const loadMilestones = async () => {
    try {
      setLoading(true);
      const data = await ApiService.getMilestones(); // ✅ Use ApiService
      console.log('Loaded milestones data:', data);
      console.log('First milestone structure:', data[0]);
      setMilestones(data);
    } catch (error) {
      console.error('Failed to load milestones:', error);
    } finally {
      setLoading(false);
    }
  };

  // Fetch milestones on load
  useEffect(() => {
    loadMilestones();
  }, []);

  // Expose refresh function globally for other components
  useEffect(() => {
    console.log('MilestoneList - Setting up window.refreshMilestones');
    window.refreshMilestones = loadMilestones;
    return () => {
      console.log('MilestoneList - Cleaning up window.refreshMilestones');
      delete window.refreshMilestones;
    };
  }, []);

  const getStatusBadgeStyle = (status) => {
    switch (status) {
      case 'Completed': return { backgroundColor: '#dcfce7', color: '#166534' };
      case 'In Progress': return { backgroundColor: '#dbeafe', color: '#1e40af' };
      case 'Pending': return { backgroundColor: '#fef3c7', color: '#92400e' };
      default: return { backgroundColor: '#f3f4f6', color: '#374151' };
    }
  };

  const handleStatusChange = async (milestoneId, newStatus) => {
    console.log('Updating milestone:', { milestoneId, newStatus });
    if (!milestoneId) {
      console.error('Milestone ID is undefined');
      return;
    }

    try {
      const updated = await ApiService.updateMilestone(milestoneId, { status: newStatus });
      setMilestones(prev =>
        prev.map(m => ((m._id || m.id) === milestoneId ? updated : m))
      );

      // Show success popup message
      setShowAlert(`✅ Milestone status updated to "${newStatus}" successfully!`);
    } catch (error) {
      console.error('Failed to update milestone:', error);
      setShowAlert('❌ Failed to update milestone status. Please try again.');
    }
  };

  const handleDelete = async (milestoneId) => {
    console.log('Deleting milestone:', milestoneId);
    if (!milestoneId) {
      console.error('Milestone ID is undefined');
      return;
    }

    if (!window.confirm('Are you sure you want to delete this milestone?')) return;
    try {
      await ApiService.deleteMilestone(milestoneId);
      setMilestones(prev => prev.filter(m => (m._id || m.id) !== milestoneId));
    } catch (error) {
      console.error('Failed to delete milestone:', error);
    }
  };

  if (loading) return <p>Loading Project-Tasks...</p>;

  return (
    <div style={{ padding: '1rem' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <h1>Project-Tasks</h1>
      </div>

      {milestones.length === 0 ? (
        <p>No project-tasks found.</p>
      ) : (
        <div
          style={{
            display: 'grid',
            gap: '1rem',
            gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
          }}
        >
          {milestones.map((milestone, index) => {
            console.log('Milestone object:', milestone);
            console.log('Available keys:', Object.keys(milestone));

            // Try multiple possible ID field names
            const milestoneId = milestone._id || milestone.id || milestone.milestoneId || milestone.__id;
            console.log('Milestone ID (_id):', milestone._id);
            console.log('Milestone ID (id):', milestone.id);
            console.log('Milestone ID (milestoneId):', milestone.milestoneId);
            console.log('Final milestoneId:', milestoneId);

            // If still no ID, use index as fallback but warn
            if (!milestoneId) {
              console.warn('No ID found for milestone, using index:', index);
            }

            return (
              <div
                key={milestoneId || Math.random()}
                style={{
                  border: '1px solid #ddd',
                  padding: '1rem',
                  borderRadius: '8px',
                }}
              >
                <h3>{milestone.title}</h3>
                <p>Project: {milestone.projectName}</p>
                <p>Due Date: {new Date(milestone.dueDate).toLocaleDateString('en-GB')}</p>
                <span
                  style={{
                    ...getStatusBadgeStyle(milestone.status),
                    padding: '4px 8px',
                    borderRadius: '12px',
                  }}
                >
                  {milestone.status}
                </span>
                <div
                  style={{
                    marginTop: '1rem',
                    display: 'flex',
                    justifyContent: 'space-between',
                  }}
                >
                  <button
                    onClick={() => {
                      const statuses = ['Pending', 'In Progress', 'Completed'];
                      const nextStatus =
                        statuses[
                        (statuses.indexOf(milestone.status) + 1) % statuses.length
                        ];
                      const actualId = milestoneId || index;
                      console.log('Button clicked - using ID:', actualId);
                      handleStatusChange(actualId, nextStatus);
                    }}
                    style={{
                      color: '#3b82f6',
                      background: 'none',
                      border: 'none',
                      cursor: 'pointer',
                    }}
                  >
                    {milestone.status === 'Completed' ? (
                      <CheckCircle />
                    ) : milestone.status === 'In Progress' ? (
                      <Clock />
                    ) : (
                      <AlertCircle />
                    )}
                  </button>
                  <button
                    onClick={() => {
                      const actualId = milestoneId || index;
                      console.log('Delete button clicked - using ID:', actualId);
                      handleDelete(actualId);
                    }}
                    style={{
                      color: '#ef4444',
                      background: 'none',
                      border: 'none',
                      cursor: 'pointer',
                    }}
                  >
                    <Trash2 />
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* Alert Box for popup messages */}
      {showAlert && (
        <AlertBox
          message={showAlert}
          onClose={() => setShowAlert(null)}
        />
      )}
    </div>
  );
};

export default MilestoneList;
